export default __webpack_public_path__ + "static/media/android-robot-bot-icon.dac3c08d.svg";